import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { GlobalService } from '../../services/global.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { UntypedFormGroup, UntypedFormControl, NgForm } from '@angular/forms';
import { MLService } from '../../services/ml-service';
import { ModelParameter } from '../mlmodel/mlModel-parameters.model';
import { Globals } from '../globals.model';

@Component({
  selector: 'app-model-execute',
  templateUrl: './model-execute.component.html',
  styleUrls: ['./model-execute.component.css']
})

export class ModelExecuteComponent implements OnInit {
  regProgress = true;
  exeProgress = false;
  myFormGroup: UntypedFormGroup;
  errorMessage = '';
  errorOutpuMsg = '';
  opsName = [];
  inputParameters: ModelParameter[];
  outputParameters: ModelParameter[];
  form_template = [];
  responseOutput = [];
  @ViewChild('f', { static: false }) registerForm: NgForm;

  constructor(
    public dialogRef: MatDialogRef<ModelExecuteComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public httpClient: HttpClient,
    private readonly globals: GlobalService,
    public globasConfig: Globals,
    public mlService: MLService
  ) { }

  ngOnInit() {
    this.regProgress = true;
    this.opsName = this.data.availalbleModel.properties.urlTemplate;
    let modelsDescUrl = this.globasConfig.config.modelsExecURL_AIML[(this.data.modelType).trim()] + (this.data.availalbleModel.name).trim() + '?api-version=2019-12-01';
    this.globals.getModelsDescriptions(this.renderFormControl, this, modelsDescUrl, this.data.accessToken);
  }

  renderFormControl(data, thisRef: ModelExecuteComponent) {
    thisRef.regProgress = true;
    thisRef.mlService.getConfigParameterWithDetails(thisRef.data.name, thisRef.data.modelConfigurationId).subscribe((data: any): void => {
      thisRef.inputParameters = data.inputParameters;
      thisRef.outputParameters = data.outputParameters;
      let formItem = [];
      let group = {};
      for (let i = 0; i < thisRef.inputParameters.length; i++) {
        {
          let obj = {};
          obj['inputModel'] = thisRef.inputParameters[i].parameterName;
          obj['label'] = thisRef.inputParameters[i].captionName;
          if (typeof (thisRef.inputParameters[i].parameterDefaultValue) === 'string') {
            obj['type'] = 'textBox';
          } else if (typeof (thisRef.inputParameters[i].parameterDefaultValue) === 'number') {
            obj['type'] = 'number';
          } else {
            obj['type'] = 'checkbox';
          }
          formItem.push(obj);
        }
        thisRef.form_template = formItem;
        thisRef.form_template.forEach(input_template => {
          group[input_template.inputModel] = new UntypedFormControl('');
        });
        thisRef.myFormGroup = new UntypedFormGroup(group);
        thisRef.regProgress = false;
      }
    }, (error: Error) => {
      thisRef.errorMessage = "Error in getting parameters list for " + thisRef.data.selectedData.name + " model";
      thisRef.regProgress = false;
    });
  }


  onSubmit() {
    this.mlService.apimAuthCodeData().subscribe((data: any): void => {
      this.errorOutpuMsg = '';
      this.exeProgress = true;
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Access-Control-Allow-Methods': 'POST',
          'Authorization': 'Bearer ' + data.accessToken
        })
      };
      const modelsExecUrl = this.globasConfig.config.modelsExecURL[(this.data.modelType).trim()] + this.opsName;
      this.mlService.modelsExecData(modelsExecUrl, this.myFormGroup.value, httpOptions).subscribe((data: any): void => {
        this.responseOutput = [];
        this.modefiedOutput(data);
        this.exeProgress = false;
      }, (error: Error) => {
        this.errorOutpuMsg = 'Error in fetching output, more details: ' + error.message;
        this.exeProgress = false;
      });
    }, (error: Error) => {
      console.log('Error while getting Bearer token, more details: ', error.message);
    });
  }

  modefiedOutput(data) {
    for (let [key, value] of Object.entries(data)) {
      for (let i = 0; i < this.outputParameters.length; i++) {
        if (this.outputParameters[i].parameterName === key) {
          let obj = {};
          obj['key'] = this.outputParameters[i].captionName;
          obj['value'] = value;
          this.responseOutput.push(obj);
        }
      }
    }
  }
}
